module.exports = __webpack_public_path__ + "img/Regional.faf36585.svg";